import { render, staticRenderFns } from "./long.vue?vue&type=template&id=63d126ef&scoped=true&"
import script from "./long.vue?vue&type=script&lang=js&"
export * from "./long.vue?vue&type=script&lang=js&"
import style0 from "./long.vue?vue&type=style&index=0&id=63d126ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d126ef",
  null
  
)

export default component.exports